import parse from 'html-react-parser'

import parsePhoneNumberFromString from 'libphonenumber-js'
import Globals from '../Globals'
import EmailValidator from 'email-validator'
import classNames from 'classnames'

const ContactFieldRender = (props) => {
    const renderField = (string) => {
        const open = (string.match(/</g) || []).length
        const close = (string.match(/>/g) || []).length

        if (open === close) {
            try {
                return parse(string)
            } catch (error) {
                return string
            }
        }
        return string
    }

    const isUrl = (field) => {
        if (field.url) {
            let url = null

            try {
                url = new URL(field.url)
            } catch (e) {
                return false
            }

            if (url != null) {
                return true
            }

            return false
        }
        return false
    }

    const isPhoneNumber = (string) => {
        const phoneNumber = parsePhoneNumberFromString(string, 'US')
        if (phoneNumber) {
            return phoneNumber.isValid()
        }
        return false
    }

    const getPhoneNumberUri = (string) => {
        const phoneNumber = parsePhoneNumberFromString(string, 'US')
        if (phoneNumber) {
            return phoneNumber.getURI()
        }
        return ''
    }

    const isEmail = (string) => {
        return EmailValidator.validate(string)
    }

    let fieldClasses = props.field.label
    if (props.field.name) {
        fieldClasses += ' '
        fieldClasses += props.field.name
    }
    if (props.name) {
        fieldClasses += ' '
        fieldClasses += props.name
    }

    const fieldStyle = {
        fontFamily: Globals.fonts[props.field.font],
        color: Globals.colors[props.field.color],
    }

    const labelClasses = classNames({
        labelWrap: true,
        isEmpty: props.field.label.length === 0,
    })

    if (isPhoneNumber(props.field.value)) {
        return (
            <div className={fieldClasses}>
                <span style={fieldStyle} className={labelClasses}>
                    {props.field.label}{' '}
                </span>
                <a
                    style={fieldStyle}
                    href={getPhoneNumberUri(props.field.value)}
                >
                    {renderField(props.field.value)}
                </a>
            </div>
        )
    }

    if (isEmail(props.field.value)) {
        return (
            <div className={fieldClasses}>
                <span style={fieldStyle} className={labelClasses}>
                    {props.field.label}{' '}
                </span>
                <a style={fieldStyle} href={'mailTo:' + props.field.value}>
                    {renderField(props.field.value)}
                </a>
            </div>
        )
    }

    if (isUrl(props.field)) {
        return (
            <div className={fieldClasses}>
                <span style={fieldStyle} className={labelClasses}>
                    {props.field.label}{' '}
                </span>
                <a style={fieldStyle} href={props.field.url}>
                    {renderField(props.field.value)}
                </a>
            </div>
        )
    }

    return (
        <div className={fieldClasses} style={fieldStyle}>
            <span className={labelClasses}>{props.field.label} </span>
            {renderField(props.field.value)}
        </div>
    )
}

export default ContactFieldRender
